import { useEffect, useState } from "react";

// Launch target — start of January 2027 (adjust if you want a specific day)
const TARGET = new Date("2027-01-01T00:00:00-05:00").getTime();

const pad = (n) => String(n).padStart(2, "0");

function compute() {
  const diff = TARGET - Date.now();
  if (diff <= 0) return { launched: true, days: 0, hours: 0, minutes: 0, seconds: 0 };
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  return { launched: false, days, hours, minutes, seconds };
}

export default function LaunchCountdown({ variant = "dark" }) {
  const [t, setT] = useState(compute);

  useEffect(() => {
    const id = setInterval(() => setT(compute()), 1000);
    return () => clearInterval(id);
  }, []);

  const isDark = variant === "dark";
  const cellCls = isDark
    ? "border border-white/25 bg-white/[0.03] backdrop-blur-sm"
    : "border border-slate-200 bg-white";
  const numCls = isDark ? "text-white" : "text-slate-900";
  const labelCls = isDark ? "text-blue-300" : "text-blue-700";
  const captionCls = isDark ? "text-white/60" : "text-slate-500";

  if (t.launched) {
    return (
      <div data-testid="launch-countdown-launched" className="inline-flex items-center gap-2 border-2 border-blue-500 bg-blue-500/10 px-4 py-2">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-400" />
        </span>
        <span className={`text-xs font-bold uppercase tracking-widest ${isDark ? "text-white" : "text-slate-900"}`}>
          Feeding Blue Is Live
        </span>
      </div>
    );
  }

  const units = [
    { k: t.days, label: "Days", testid: "cd-days" },
    { k: pad(t.hours), label: "Hours", testid: "cd-hours" },
    { k: pad(t.minutes), label: "Minutes", testid: "cd-minutes" },
    { k: pad(t.seconds), label: "Seconds", testid: "cd-seconds" },
  ];

  return (
    <div data-testid="launch-countdown" className="w-full max-w-lg">
      <div className={`text-[10px] font-bold uppercase tracking-widest mb-3 ${labelCls}`}>
        Countdown to Launch · January 1, 2027
      </div>
      <div className="grid grid-cols-4 gap-2 sm:gap-3">
        {units.map((u) => (
          <div key={u.label} data-testid={u.testid} className={`${cellCls} px-3 py-3 sm:py-4 text-center`}>
            <div className={`font-display text-2xl sm:text-3xl md:text-4xl font-black tabular-nums ${numCls}`}>
              {u.k}
            </div>
            <div className={`text-[9px] sm:text-[10px] font-bold uppercase tracking-widest mt-1 ${captionCls}`}>
              {u.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
